import { Paper } from '@mui/material'
import ProfileAccount from '../../Profile/components/ProfileAccount'

export const Account = () => {
    return (
        <Paper
            // temporary override for profile account
            sx={{
                background: (theme) => theme.palette.background.default,
                overflow: 'auto',
                '> div': {
                    padding: '0 !important',
                },
            }}
        >
            <ProfileAccount />
        </Paper>
    )
}
